import {BaseLogicalOperator} from '../base-logical-operator';
import {IConfigurationEvaluationContext} from '../../../configuration-evaluation-context/configuration-evaluation-context.interface';

export class AndLogicalOperator extends BaseLogicalOperator {

  evaluate(context: IConfigurationEvaluationContext): boolean {
    if(this.rules.length === 0) {
      return false;
    }

    for(let i = 0, len = this.rules.length; i < len; i++) {
      let rule = this.rules[i];
      if(!rule.evaluate(context)) {
        return false;
      }
    }

    return true;
  }
}
